import { Input } from "antd";
import { Control, Controller } from "react-hook-form";
import { HTMLInputTypeAttribute, ReactNode } from "react";

interface IProps {
  name: string;
  placeholder: string;
  control: Control<any, any>;
  type: HTMLInputTypeAttribute;
  prefix?: ReactNode;
}

export default function NormalInput({
  name,
  placeholder,
  control,
  prefix,
  type,
}: IProps) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={""}
      render={({ field, fieldState: { error } }) => (
        <div className="w-full">
          <Input
            prefix={prefix}
            id={name}
            type={type}
            className="h-auto w-full py-2 outline-none"
            {...field}
            placeholder={placeholder}
            status={error ? "error" : undefined}
          />
          <span className="text-xs text-red-500">{error?.message}</span>
        </div>
      )}
    />
  );
}
